<template>
    <div>
        <card-header title="New User" icon="fa-plus"/>

        <card-body>
            <org-user-form :user="user" :org="org"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!user.first_name || !user.last_name || !user.username || !user.password"
                    ><i class="fas fa-plus mr-2"></i>New User
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import CourseForm from "@/cards/courses/CourseForm";
    import ConferenceForm from "@/cards/conferences/ConferenceForm";

    import {client as http} from "@/http_client";
    import OrgUserForm from "./UserForm.vue";

    export default {
        components: {OrgUserForm, CardHeader, CardToolbar, CardBody, CardFooter, CourseForm},
        props: ['card'],
        data() {
            return {
                org: {},
                user: {}
            };
        },
        methods: {
            loadOrg: function() {
                this.$emit('loading', true);
                http.get('organizations/self', {force: true}).then(response => {
                    this.org = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                this.$emit('loading', true);
                http.post('organizations/users', this.user, {force: true}).then(response => {
                    this.$reloadCard('org-settings');
                    this.$closeCard(this.card);
                }).catch(err => {
                    if (err.response.status === 400) {
                        window.alert('Username (email) already exists.');
                    } else {
                        window.alert('An error occurred while saving the user.');
                    }
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.loadOrg();
        }
    };
</script>
